import validate from 'validate.js';
import i18n from '~/i18n/locale';

const URL_PATTERN = /https?:\/\/|www\.|[a-z0-9-]+\.[a-z]{2,}\//i;
const EMOJI_PATTERN = /\p{Extended_Pictographic}/u;

validate.validators.spamContent = function(value, options) {
  if (!value) return;

  if (URL_PATTERN.test(value) || EMOJI_PATTERN.test(value)) {
    return options.message || i18n.t('pay.js.validations.spam_content');
  }
};
